const AiIcon = '/images/icons/integrations/ai.svg';
const PsIcon = '/images/icons/integrations/ps.svg';
const FigmaIcon = '/images/icons/integrations/figma.svg';
const SketchIcon = '/images/icons/integrations/sketch.svg';
const FileIcon = '/images/icons/integrations/file.svg';

export const getExtentionIcon = (file, url) => {
    const fileName = file?.name || file;
    const fileNameArr = fileName.split('.');
    const fileExtension = fileNameArr[fileNameArr.length - 1].toLowerCase();

    switch (fileExtension) {
      case 'jpg': case 'png': case 'gif': case 'jpeg': case 'jfif': case 'pjpeg':
        return url;

      case 'ai': case 'eps': case 'svg': 
        return AiIcon;

      case 'psdt': case 'psd': case 'pdd':
        return PsIcon;

      case 'fig':
        return FigmaIcon;

      case 'sketch':
        return SketchIcon;

      default: return FileIcon;
    };
  };